// Client-side email format check used by the coverage form's pro-forma flow.
// Extracted to its own module (AHD-7879) so the form and its co-located result
// panel can share it without a circular import.
// Server-side normalization for downstream services lives in normalize-email.ts.
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/
